import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AddressesForm } from '../login-form/login-form.component';
import {UserDataDTO} from './login-form.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private isLoggedInSubject = new BehaviorSubject<boolean>(false);
    private userNameSubject = new BehaviorSubject<string>('');

    constructor() {
        const storedUserName = localStorage.getItem('user');
        if (storedUserName) {
            this.isLoggedInSubject.next(true);
            this.userNameSubject.next(storedUserName);
        }
    }

    setUser(user: UserDataDTO) {
        const userName = user.name;
        this.isLoggedInSubject.next(true);
        this.userNameSubject.next(userName);

        localStorage.setItem('user', userName);
    }

    setAddresses(addresses: AddressesForm) {
        localStorage.setItem('addresses', JSON.stringify(addresses.addresses));
    }

    getUser() {
        return this.userNameSubject.asObservable(); // Retorna un Observable
    }

    getIsLoggedIn() {
        return this.isLoggedInSubject.asObservable(); // Retorna un Observable
    }

    logout() {
        this.isLoggedInSubject.next(false);
        this.userNameSubject.next('');

        window.location.reload();

        localStorage.removeItem('user');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('addresses');
        localStorage.removeItem('password');
        localStorage.removeItem('token');
    }
}
